import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, connectAuthEmulator, browserSessionPersistence, setPersistence } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDnB8K1MY_U9c_3eM3oGFCRyU97IUsIQns",
  authDomain: "benetica-ff09b.firebaseapp.com",
  projectId: "benetica-ff09b",
  storageBucket: "benetica-ff09b.firebasestorage.app",
  messagingSenderId: "728778498375",
  appId: "1:728778498375:web:13d68aa6983f5f2bddec62"
};

// Initialize Firebase with regional endpoint configuration
const app = initializeApp({
  ...firebaseConfig,
  authDomain: "benetica-ff09b.firebaseapp.com", // Ensure this is correct
  apiKey: "AIzaSyDnB8K1MY_U9c_3eM3oGFCRyU97IUsIQns" // Ensure API key is correct
});

// Initialize Firebase services
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

// =============================================================
// CRITICAL: Configure auth settings to avoid authentication errors
// =============================================================

// Detect environment for appropriate configuration
const isDevelopment = process.env.NODE_ENV === 'development';
const isLocalhost = window.location.hostname === 'localhost' || 
                    window.location.hostname === '127.0.0.1';

// Set default persistence for all auth methods
// This helps with the "auth/invalid-credential" errors
try {
  setPersistence(auth, browserSessionPersistence)
    .then(() => {
      console.log("Auth persistence set to session");
    })
    .catch(error => {
      console.error("Error setting auth persistence:", error);
    });
} catch (e) {
  console.error("Error setting auth persistence:", e);
}

// Configure custom auth settings
// This addresses many common auth errors including captcha and invalid-credential issues
try {
  // Set session persistence for more reliable auth
  auth.settings = {
    appVerificationDisabledForTesting: false, // Set to true ONLY for test environments 
    forceRecaptchaFlow: false
  };
  
  // Increase auth timeout
  auth.tenantId = null; // Ensure no tenant ID is set (can cause issues)
  
  // Add a small delay before initializing auth operations
  setTimeout(() => {
    console.log("Auth ready");
  }, 300);
} catch (e) {
  console.error("Error configuring auth settings:", e);
}

// For development/testing - use emulators if needed
if (isDevelopment && isLocalhost && false) { // Set to true if using emulators
  // Connect to emulators for local development
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: false });
  console.log("Using Firebase Auth Emulator");
}

// Enable phone auth specific settings
if (isDevelopment) {
  console.log("Firebase development mode enabled");
  
  // Only for development - enable test mode flags
  window.FIREBASE_TESTMODE = true;
  
  // Enable this only for testing with test phone numbers
  // auth.settings.appVerificationDisabledForTesting = true;
}

// CRITICAL: Disable App Check completely to avoid ReCAPTCHA errors
// This is needed to fix the vendor login issues with error code 400 and "AppCheck: ReCAPTCHA error"
const enableAppCheck = false;

// App Check configuration - only if enabled
if (enableAppCheck) {
  if (isDevelopment) {
    // Debug mode for development
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
  
  try {
    // Initialize App Check with appropriate configuration
    const reCaptchaSiteKey = '6LdK_ZUpAAAAAEgGpvwUZpW2rtNan2H4waZlZ6ZD';
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(reCaptchaSiteKey),
      isTokenAutoRefreshEnabled: true
    });
  } catch (e) {
    console.warn("Could not initialize Firebase AppCheck:", e);
  }
}

// Export configured Firebase instances
export { app, db, auth, storage };

// Add diagnostic functions to help with debugging
export const checkFirebaseAuthStatus = () => {
  return {
    authInitialized: !!auth,
    currentUser: auth.currentUser,
    authDomain: firebaseConfig.authDomain,
    projectId: firebaseConfig.projectId
  };
};

// Helper function to clear auth state
export const clearAuthState = async () => {
  try {
    await auth.signOut();
    // Clear any potential session or local storage items
    localStorage.removeItem('firebase:authUser:AIzaSyDnB8K1MY_U9c_3eM3oGFCRyU97IUsIQns:[DEFAULT]');
    sessionStorage.removeItem('firebase:authUser:AIzaSyDnB8K1MY_U9c_3eM3oGFCRyU97IUsIQns:[DEFAULT]');
    console.log("Auth state cleared");
    return true;
  } catch (e) {
    console.error("Error clearing auth state:", e);
    return false;
  }
};